import { FC } from 'react';

type CollapsibleLayoutProps = {
  subheaderContent: React.ReactNode;
  children: React.ReactNode;
};

export const PageLayout: FC<CollapsibleLayoutProps> = ({
  subheaderContent,
  children,
}) => {
  return (
    <div className="flex flex-col w-full h-full">
      {subheaderContent}
      <div className="flex overflow-hidden grow items-start">{children}</div>
    </div>
  );
};
